import { Injectable } from '@angular/core';

/**
 * Detects a new frontend deployment while the app is already running: an open tab (or a browser that
 * still has a stale index.html/bundle cached) never re-fetches anything on its own, so we poll index.html
 * with cache disabled and compare its ETag/Last-Modified fingerprint against the one seen at startup.
 */
@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  private knownFingerprint: string | null = null;

  async init(): Promise<void> {
    this.knownFingerprint = await this.fetchFingerprint();
  }

  async hasUpdate(): Promise<boolean> {
    if (!this.knownFingerprint) {
      return false;
    }
    const fingerprint = await this.fetchFingerprint();
    return fingerprint !== null && fingerprint !== this.knownFingerprint;
  }

  private async fetchFingerprint(): Promise<string | null> {
    try {
      const response = await fetch('/index.html', {cache: 'no-store'});
      return response.headers.get('ETag') ?? response.headers.get('Last-Modified');
    } catch {
      return null;
    }
  }
}
